import Vue from 'vue';
import VueI18n from 'vue-i18n';

const messages = {
  pl: {
    invalidPassword: 'Niepoprawne dane logowania',
    useCard: 'Użyj karty',
    logged: 'Zostałeś zalogowany',
    urlIncorrect: `Ale url na który powinniśmy cię przekierować jest niepoprawny. 
Prawdopodobnie ktoś próbował wykraść twoje dane.`,
  },
  en: {
    invalidPassword: 'Invalid credentials',
    useCard: 'Use card',
    logged: 'You have been logged successfully',
    urlIncorrect: `But the provided url is incorrect. 
Someone might have tried to steal your data.`,
  },
};

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  messages,
});

export default i18n;
